import Api from 'client/api/v2/Api';
import axios from 'axios';

class RemoteAssistApi extends Api {
  constructor() {
    super();
    this.baseUrl = '/api/v2/remoteassist';
  }

  async getConfig() {
    const url = `${this.baseUrl}/settings`;
    await this.initialize();
    const resp = await axios.get(url);
    return resp.data;
  }

  async postConfig(data) {
    const url = `${this.baseUrl}/settings`;
    await this.initialize();
    const resp = await axios.post(url, data);
    return resp.data;
  }

  /**
   * Get the JWT token
   * @param {Object} payload [systemId]
   * @returns {Object} [token]
   */
  getToken(payload) {
    const url = `${this.baseUrl}/token`;

    return this.initialize()
      .then(() => axios.post(url, payload))
      .then((resp) => resp.data);
  }
}

export default new RemoteAssistApi();
